import { render, staticRenderFns } from "./LeaveRoomPopup.vue?vue&type=template&id=79214244&scoped=true"
import script from "./LeaveRoomPopup.vue?vue&type=script&lang=ts"
export * from "./LeaveRoomPopup.vue?vue&type=script&lang=ts"
import style0 from "./LeaveRoomPopup.vue?vue&type=style&index=0&id=79214244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79214244",
  null
  
)

export default component.exports